export const constants = {
    PAGE_SIZE : 10
}